import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './LinkAction.css';

const LinkAction = ({ children, dark, disabled, href, size }) => {
  const cx = classnames.bind(styles);
  const linkClasses = cx('link', size, { disabled, dark });

  return (
    <a className={linkClasses} href={href}>
      {children}
    </a>
  );
};

LinkAction.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  dark: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf([
    's',
    'm',
    'l'
  ])
};

LinkAction.defaultProps = { size: 'm', href: '#' };

LinkAction.displayName = 'LinkAction';

export default LinkAction;



// WEBPACK FOOTER //
// ./src/uis/elements/Link/LinkAction/LinkAction.js